import React from 'react'

const IsmSpec = () => {
  return (
    <div style={{height: '100vh'}}>Coming soon...</div>
  )
}

export default IsmSpec